module.exports = __webpack_public_path__ + "static/media/Goethe_instut-01.c9cc71df.jpg";